import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { faSpinnerThird } from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'app-blocker',
  templateUrl: './blocker.component.html',
  styleUrls: ['./blocker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlockerComponent {
  loadingIcon = faSpinnerThird;

  @Input()
  text: string | null = null;
}
